export default __webpack_public_path__ + "static/media/fight_button_active.7994adf6.png";